<ntap-prime-common-itemview #itemView></ntap-prime-common-itemview>
<div>
    <p-button (click)="toggleVarijablu()" label="{{ trenutnaVarijabla === 'rezultat_inventure' ? 'Popis' : 'Rezultat inventure' }}"></p-button>
</div>
<br>
<ng-container *ngIf="currentListViewState && itemView.activeTab === 0" ntapDynamicFormProvider>
    <ng-container ntapFilterViewProvider [viewName]="currentListViewName" [viewState]="currentListViewStateFilter">
        <ng-container ntapListViewProvider [viewName]="currentListViewName" [viewState]="currentListViewState">
            <ntap-dynamic [compId]="INIT_COMP_ID"></ntap-dynamic>
        </ng-container>
    </ng-container>
</ng-container>